import axios from 'axios'
import convertSession from '@/api/converters/session'

/**
 * Get single session
 * @param {Number} id Session ID
 */
function getSingle (id) {
  return axios
    .get(`sessions/${id}/`)
    .then(response => convertSession(response.data))
}

/**
 * Create new session
 * @param {Object} data Session data
 * @param {Number} data.coaching Coaching ID
 * @param {String} data.date Date
 * @param {String} data.timeStart Start time
 * @param {String} data.timeEnd End time
 * @param {String} [data.location] Location
 * @param {String} [data.comment] Comment
 */
function create (data) {
  return axios
    .post('sessions/', {
      coaching: data.coaching,
      date: data.date,
      start: data.timeStart,
      end: data.timeEnd,
      location: data.location,
      comment: data.comment
    })
}

/**
 * Update session
 * @param {Number} id session ID
 * @param {Object} data Session data
 * @param {String} data.date Date
 * @param {String} data.timeStart Start time
 * @param {String} data.timeEnd End time
 * @param {String} [data.location] Location
 * @param {String} [data.comment] Comment
 */
function update (id, data) {
  return axios
    .patch(`sessions/${id}/`, {
      date: data.date,
      start: data.timeStart,
      end: data.timeEnd,
      location: data.location,
      comment: data.comment
    })
}

/**
 * Accept new session
 * @param {Number} id Session ID
 */
function accept (id) {
  return axios
    .get(`sessions/${id}/accept/`)
}

/**
 * Reject new session
 * @param {Number} id Session ID
 */
function reject (id) {
  return axios
    .get(`sessions/${id}/reject/`)
}

export default {
  getSingle,
  create,
  update,
  accept,
  reject
}
